export default function validate(data) {
    let errors = {};

    if (!data.identifier) {
        errors.identifier = 'identifier_error';
    }

    if (!data.password) {
        errors.password = 'password_error';
    }

    if (!data.contractNumber) {
        errors.contractNumber = 'contractNumber_error';
    }

    if (data.first && !data.checkboxChecked) {
        errors.checkboxChecked = 'checkboxChecked_error';
    }

    return errors
}